import { useState } from 'react';
import Agents from '../Agents/Agents';
import Dealer from '../Dealer/Dealer';

// Single "Team" screen with sub-tabs for Agents and Dealers,
// so the sidebar shows one entry instead of two.
const Team = () => {
  // Read the logged-in user's role to decide which tabs to show.
  let role = null;
  try {
    const userDetail = JSON.parse(localStorage.getItem('UserDetail'));
    role = userDetail?.role;
  } catch (err) {
    console.error('Error parsing user detail from localStorage:', err);
  }

  const isDealer = role === 'dealer';

  // Dealers only manage Agents; distributors see Dealers first, then Agents.
  const [activeTab, setActiveTab] = useState(isDealer ? 'agents' : 'dealers');

  const tabs = isDealer
    ? [{ key: 'agents', label: 'Agents' }]
    : [
        { key: 'dealers', label: 'Dealers' },
        { key: 'agents', label: 'Agents' },
      ];

  return (
    <div className="p-0 space-y-6">
      {/* Page Title with Top Spacing */}
      <div className="mt-2 mb-4 flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-800">Team</h1>
      </div>

      {/* Sub-tab switcher wrapped in a white card container - only shown if there are multiple tabs */}
      {!isDealer && (
        <div className="bg-white p-4 rounded-xl shadow-sm flex items-center mb-6">
          <ul className="flex flex-wrap text-sm font-medium text-center">
            {tabs.map((t) => (
              <li key={t.key} className="mr-2">
                <button
                  onClick={() => setActiveTab(t.key)}
                  className={`${
                    activeTab === t.key
                      ? 'bg-[#FF0404] text-white'
                      : 'bg-[#FEF5F5] text-[#1F1715]'
                  } text-[12px] font-medium px-5 py-2.5 rounded-full transition-all duration-200`}
                >
                  {t.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Active tab content */}
      <div>
        {isDealer || activeTab === 'agents' ? <Agents /> : <Dealer />}
      </div>
    </div>
  );
};

export default Team;
